const base=(process.env.PUBLIC_URL||'')+'/models/face';
let detectorPromise;
export function photoFileError(file){return !file||!file.size||file.size>8*1024*1024||!['image/jpeg','image/png','image/webp'].includes(file.type)?'photoInvalidFile':null;}
export function faceResultError(detections,width,height){
 if(!detections?.length)return 'photoNoFace';
 if(detections.length!==1)return 'photoSeveralFaces';
 const b=detections[0].boundingBox;
 if(!b||b.width<width*.20||b.height<height*.20)return 'photoNotClear';
 const vw=Math.max(0,Math.min(width,b.originX+b.width)-Math.max(0,b.originX)),vh=Math.max(0,Math.min(height,b.originY+b.height)-Math.max(0,b.originY));
 return vw*vh/(b.width*b.height)<.7?'photoNotClear':null;
}
async function getDetector(){
 if(!detectorPromise){
   const task=(async()=>{
     const {FaceDetector,FilesetResolver}=await import(/* webpackIgnore: true */ `${base}/vision_bundle.mjs`);
     const vision=await FilesetResolver.forVisionTasks(base+'/wasm');
     let binaryUrl;
     try{
       // Gzip is served as a regular local file: no IIS compression module needed.
       if(typeof DecompressionStream==='function'){
         const response=await fetch(vision.wasmBinaryPath+'.gz');if(!response.ok)throw new Error('photoUnavailable');
         const bytes=await new Response(response.body.pipeThrough(new DecompressionStream('gzip'))).arrayBuffer();
         binaryUrl=URL.createObjectURL(new Blob([bytes],{type:'application/wasm'}));vision.wasmBinaryPath=binaryUrl;
       }
       return await FaceDetector.createFromOptions(vision,{baseOptions:{modelAssetPath:base+'/blaze_face_short_range.tflite',delegate:'CPU'},runningMode:'IMAGE',minDetectionConfidence:.65,minSuppressionThreshold:.3});
     }finally{if(binaryUrl)URL.revokeObjectURL(binaryUrl);}
   })();
   let timer,expired=false;
   detectorPromise=Promise.race([task,new Promise((_,reject)=>{timer=setTimeout(()=>{expired=true;reject(new Error('photoUnavailable'));},45000);})]).catch(e=>{detectorPromise=null;if(expired)task.then(x=>x.close()).catch(()=>{});throw e;}).finally(()=>clearTimeout(timer));
 }
 return detectorPromise;
}
async function decode(file){
 const url=URL.createObjectURL(file),image=new Image();
 try{
   await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=()=>reject(new Error('photoInvalidFile'));image.src=url;});
   if(image.naturalWidth<160||image.naturalHeight<160||image.naturalWidth*image.naturalHeight>40000000)throw new Error('photoInvalidFile');
   const scale=Math.min(1,960/Math.max(image.naturalWidth,image.naturalHeight)),canvas=document.createElement('canvas');
   canvas.width=Math.round(image.naturalWidth*scale);canvas.height=Math.round(image.naturalHeight*scale);
   const context=canvas.getContext('2d');if(!context)throw new Error('photoUnavailable');context.drawImage(image,0,0,canvas.width,canvas.height);
   return canvas;
 }finally{URL.revokeObjectURL(url);}
}
export async function checkProfilePhoto(file,dependencies={}){
 const issue=photoFileError(file);if(issue)throw new Error(issue);
 const canvas=await (dependencies.decode||decode)(file);
 try{
   let detector;try{detector=await (dependencies.getDetector||getDetector)();}catch{throw new Error('photoUnavailable');}
   const result=detector.detect(canvas),error=faceResultError(result.detections,canvas.width,canvas.height);if(error)throw new Error(error);return true;
 }catch(e){if(['photoNoFace','photoSeveralFaces','photoNotClear','photoUnavailable'].includes(e.message))throw e;throw new Error('photoUnavailable');}
 finally{canvas.width=1;canvas.height=1;}
}
